const colors = {
  blue: {
    '100': '#D7E5FA',
    '200': '#B2CBF6',
    '300': '#85A6E5',
    '400': '#6182CC',
    '500': '#3455AA',
    '600': '#264192',
    '700': '#1A2F7A',
    '800': '#102062',
    '900': '#091551',
  },
  gray: {
    '100': '#F3F9F9',
    '200': '#E8F2F4',
    '300': '#CDDADE',
    '400': '#ACB8BD',
    '500': '#808C92',
    '600': '#5D707D',
    '700': '#405669',
    '800': '#283D54',
    '900': '#182B46',
  },
  green: {
    '100': '#D6F9D4',
    '200': '#AAF4AE',
    '300': '#7ADF89',
    '400': '#53C06E',
    '500': '#25974C',
    '600': '#1B8148',
    '700': '#126C43',
    '800': '#0B573C',
    '900': '#074837',
  },
  orange: {
    '100': '#FFF8CC',
    '200': '#FFEE99',
    '300': '#FFE266',
    '400': '#FFD73F',
    '500': '#FFC400',
    '600': '#DBA300',
    '700': '#B78400',
    '800': '#936700',
    '900': '#7A5200',
  },
  red: {
    '100': '#FCE2CE',
    '200': '#FABE9F',
    '300': '#F1906E',
    '400': '#E36549',
    '500': '#D12714',
    '600': '#B3110E',
    '700': '#960A12',
    '800': '#790616',
    '900': '#640319',
  },
  button: {
    primary: {
      default: '#2165ac',
      hover: '#1E5EAA',
      focus: '#1E5EAA',
    },
    secondary: {
      default: '#36846b',
      hover: '#36846b',
      focus: '#36846b',
    },
  },
  font: {
    ink: '#163A50',
    pencil: '#66748E',
    placeholder: '#ADADAD',
    error: '#FF483B',
    red: '#E21D0F',
    green: '#25974C',
    orange: '#2165ac',
    blue: '#042552',
    primary: '#2165ac',
    darken: '#284B75',
  },
  bg: {
    gray: '#F1F3F7',
    footer: '#F5F3F0',
    disabled: '#EDF0F2',
    primary: '#2165ac',
    border: '#F9F9F9',
    primary50: '#87CEEB',
    darken: '#1D1D1D',
  },
  border: '#E8E8E9',
} as const;

export type Colors = typeof colors;

export default colors;
